module.exports = __webpack_public_path__ + "static/media/nodata.96f47ace.svg";